export default "__VITE_PUBLIC_ASSET__07759f9d__"